import { t, Trans } from '@lingui/macro';
import { BookingTimeWindowPicker, ContentWrapper, FixedBottomBarContainer, NoddiButton } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useNavigate } from 'react-router-dom';
import getCommonTranslations from '../../../commonTranslations';
import { SelectedTimeWindow } from '../../../components/BookingFlow/SelectedTimeWindow';
import {
  useBookingProposalActions,
  useBookingProposalAddress,
  useBookingProposalItems,
  useBookingProposalSlug,
  useBookingProposalTimeWindow
} from '../../../stores/bookingProposalStore';
import { WrapperWithModalButton } from '../../BookingFlow/TimeWindows/WrapperWithModalButton';

export const BookingProposalTimeWindowPicker = () => {
  const address = useBookingProposalAddress();
  const bookingProposalItems = useBookingProposalItems();
  const bookingTimeWindow = useBookingProposalTimeWindow();
  const { setBookingTimeWindow } = useBookingProposalActions();
  const navigate = useNavigate();
  const slug = useBookingProposalSlug();
  return (
    <div>
      <ContentWrapper widerScreen title={t`When is it convenient for us to come to you?`} className='mb-24'>
        <WrapperWithModalButton>
          <BookingTimeWindowPicker
            address={address!}
            cars={bookingProposalItems.map((bookingProposalItem) => ({
              licensePlate: bookingProposalItem.car.licensePlate,
              selectedSalesItemIds: bookingProposalItem.salesItems.map((salesItem) => salesItem.item.id)
            }))}
            selectedDeliveryWindow={bookingTimeWindow}
            customFromDate={undefined}
            onAvailableSelect={(timeWindow) => {
              setBookingTimeWindow(timeWindow);
            }}
            translations={getCommonTranslations().timePicker}
          />
        </WrapperWithModalButton>
      </ContentWrapper>
      {bookingTimeWindow && (
        <FixedBottomBarContainer>
          <SelectedTimeWindow selectedTimeWindow={bookingTimeWindow} />
          <div className='flex w-full justify-end'>
            <NoddiButton
              endIcon='ArrowRight'
              onClick={() => {
                navigate(customerRoutes.bookingProposalConfirmation.getPath({ slug }));
              }}
            >
              <Trans>Next</Trans>
            </NoddiButton>
          </div>
        </FixedBottomBarContainer>
      )}
    </div>
  );
};
